<template>
	<div class="reservation-app-item" :class="{ 'is-disabled': isDisabled }">
		<header class="reservation-app-item__header" @click="toggleContent">
			<div class="label-group">
				<i :class="labelIcon"></i>
				{{ label }}
			</div>
			<div class="arrow-icon">
				<i :class="arrowIcon"></i>
			</div>
		</header>
		<div v-show="isOpenContent" class="reservation-app-item__content">
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		step: {
			type: Number,
			required: true,
		},
		labelIcon: {
			type: String,
			default: 'ri-menu-line',
		},
	},
	computed: {
		stepKey() {
			return `step${this.step}`;
		},
		label() {
			return this.$store.getters['reservationStore/reservationFormItemLabel'](
				this.stepKey,
			);
		},
		isOpenContent() {
			return this.$store.getters['reservationStore/isOpenReservationFormItem'](
				this.stepKey,
			);
		},
		isDisabled() {
			return this.$store.getters[
				'reservationStore/isDisabledReservationFormItem'
			](this.stepKey);
		},
		arrowIcon() {
			return {
				'ri-arrow-down-s-line': !this.isOpenContent,
				'ri-arrow-up-s-line': this.isOpenContent,
			};
		},
	},
	methods: {
		toggleContent() {
			if (this.isDisabled) return;

			const payload = {
				stepKey: this.stepKey,
				isOpen: !this.isOpenContent,
			};
			this.$store.commit(
				'reservationStore/setOpenReservationFormItem',
				payload,
			);
		},
	},
};
</script>

<style scoped>
.reservation-app-item.is-disabled {
	color: #e2e2e2;
	cursor: no-drop;
}

.reservation-app-item__header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	min-height: 2.875rem;
	padding: 0 0.75rem;
	border-bottom: 1px solid #e2e2e2;
	font-size: 1rem;
	font-weight: 300;
	line-height: 1;
}

.label-group i {
	min-width: 1.5625rem;
	font-size: 1rem;
	vertical-align: middle;
}

.arrow-icon i {
	color: #c8c8c8;
	font-size: 1.25rem;
}

.reservation-app-item__content {
	padding: 1.25rem 0.75rem;
	font-size: 1rem;
	font-weight: 300;
}
</style>
